import {connect} from "react-redux"
import State from "../../ducks/state"
import {setIsInPrimaryNav, setPrimaryNavIndex} from "../../ducks/primary-nav"
import {setIsInSecondaryMeganav} from "../../ducks/secondary-nav"
import {isPrimaryNavbarLink} from "../../utils/primaryNav"

type Anchor = "top" | "bottom" | "left" | "right"

export const mapStateToProps = (state: State) => {
    const {
        primarynav: {isInPrimaryNav, activeDepartmentIndex, items, active},
        secondarynav: {isInSecondaryNav},
    } = state
    const open = active
    let anchor: Anchor = "left"
    const isLastItem = activeDepartmentIndex >= items?.length - 1
    const isPrimaryNavbarLinkActive = isPrimaryNavbarLink(items[activeDepartmentIndex]?.viewType)
    if (isLastItem) {
        anchor = "right"
    }
    return {
        anchor,
        open,
        isInSecondaryNav,
        isInPrimaryNav,
        templating: state.template,
        isPrimaryNavbarLinkActive,
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        deactivateIndex: () => {
            dispatch(setPrimaryNavIndex(-1, ""))
            dispatch(setIsInSecondaryMeganav(false))
            dispatch(setIsInPrimaryNav(false))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)
